export class MsgTemplateData {
  fullName: string;
  resortName: string;
  firstName: string;
  lastName: string;
  adrDevelopmentName: string;
  publicWebsite: string;
  unsubscribe: string;
  confirmationNumber: string;
  reservationId: string;
  emailAddress: string;
  mobilePhone: string;
  checkInDateTime: string;
  checkOutDateTime: string;
  realtorProfileId: any;
}
